export default __webpack_public_path__ + "static/media/309.6035e062.jpg";